import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'
import LoadingSpinnerOverlay from './LoadingSpinnerOverlay'
import { useNavigate } from 'react-router-dom'
import Button from './Button'
import { useIntl } from 'react-intl'

const LinkWithStatus = (props) => {
  const {
    type,
    htmlType,
    href,
    className,
    style,
    disabled=false,
    title,
    confirmText,
    confirmTitle,
    onClickFunc,
    // Opt-in test ID for E2E locators, forwarded to the inner Button.
    testId,
  } = props

  const [active, activate] = useState(false)
  const navigate = useNavigate()
  const intl = useIntl()
  const [modal, contextHolder] = Modal.useModal()

  const resolveOnClick = () => {
    activate(false)
    if (onClickFunc) {
      onClickFunc()
      activate(false)
    } else {
      navigate(href)
    }
  }

  useEffect(() => {
    if (active) {
      resolveOnClick()
    }
  }, [active])

  const onConfirm = () => {
    activate(true)
  }

  const showConfirmationAlert = () => {
    modal.confirm({
      title: confirmTitle || intl.formatMessage({ id: 'forms.info' }),
      content: confirmText,
      cancelText: intl.formatMessage({ id: 'forms.cancel' }),
      maskClosable: true,
      centered: true,
      onOk: () => {
        onConfirm()
      },
    })
  }

  const onClick = () => {
    if (confirmText) {
      showConfirmationAlert()
    } else {
      onConfirm()
    }
  }

  return (
    <>
      <Button
        testId={testId}
        type={type}
        htmlType={htmlType}
        className={className}
        disabled={disabled}
        onClick={onClick}
      >
        {props.children || title}
      </Button>
      {contextHolder}
      <LoadingSpinnerOverlay active={active}></LoadingSpinnerOverlay>
    </>
  )
}

LinkWithStatus.propTypes = {
  type: PropTypes.string,
  htmlType: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  confirmTitle: PropTypes.string,
  onClickFunc: PropTypes.func,
  children: PropTypes.any,
  testId: PropTypes.string,
}

export default LinkWithStatus
